import type { RouterEvent } from 'next/dist/client/router';
import { useEffect } from 'react';

import { useRouter } from '@/hooks/useRouter';

export const useOnRouteChange = (
  callback: () => Promise<unknown> | unknown,
  opts?: {
    deps?: unknown[];
    eventType?: RouterEvent;
  },
) => {
  const { events } = useRouter();
  const { deps, eventType } = {
    eventType: 'routeChangeStart' as RouterEvent,
    deps: [],
    ...opts,
  };

  useEffect(() => {
    events.on(eventType, callback);
    return () => {
      events.off(eventType, callback);
    };
  }, deps);
};
